var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M294.9,142.7C293,66.3,230.1,5,152.6,5C76.1,5,13.8,64.9,10.4,140.1c-0.1,2.1-0.1,4.1-0.1,6.2 c0,26.7,7.5,51.6,20.4,73L5,295l78.8-25.1c20.4,11.2,43.8,17.6,68.8,17.6c78.6,0,142.3-63.2,142.3-141.3 C295,145.1,295,143.9,294.9,142.7z M152.6,265c-24.3,0-46.9-7.2-65.8-19.7l-46,14.7l14.9-44.1C41.4,196.3,33,172.3,33,146.3 c0-3.9,0.2-7.7,0.6-11.5c5.9-60.1,57-107.2,119.1-107.2c62.8,0,114.5,48.3,119.3,109.5c0.3,3.1,0.4,6.1,0.4,9.3 C272.3,211.8,218.6,265,152.6,265z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M217.9,174.8c-3.5-1.7-20.7-10.1-23.9-11.3c-3.2-1.2-5.5-1.7-7.9,1.7 c-2.3,3.5-9.1,11.3-11.1,13.5c-2.1,2.3-4.1,2.6-7.6,0.9c-3.5-1.7-14.7-5.3-28.1-17.2c-10.3-9.1-17.4-20.5-19.4-23.9 c-2-3.5-0.2-5.3,1.5-7.1c1.6-1.6,3.5-4.1,5.3-6.1c0.5-0.6,0.9-1.1,1.3-1.7c0.8-1.3,1.4-2.5,2.2-4.1c1.2-2.3,0.6-4.3-0.3-6.1 c-0.9-1.7-7.9-18.8-10.8-25.7c-2.9-6.9-5.8-5.7-7.9-5.7c-2,0-4.3-0.3-6.7-0.3c-2.3,0-6.1,0.9-9.3,4.3C92.2,89.6,83.2,98,83.2,115 c0,4,0.7,8,1.8,11.8c3.5,12.2,11.1,22.3,12.5,24c1.7,2.3,24.1,38.4,59.6,52.3c35.5,13.8,35.5,9.2,41.9,8.6 c6.4-0.5,20.7-8.3,23.5-16.5c2.9-8.1,2.9-15,2.1-16.5C223.7,177.4,221.3,176.5,217.9,174.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.01f47583111435c069ea72d1cab9d70d.svg";
export { ForwardRef as ReactComponent };